/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseService } from './BaseService';

export class ClientSpeechService extends BaseService {
    getSpeechRecogniser = (setContent, setIsRecordingSpeech): SpeechRecognition => {
        
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;  
        let recognition;

        if (SpeechRecognition) {  
            recognition = new (window.SpeechRecognition ||
                window.webkitSpeechRecognition ||
                (<any>window).mozSpeechRecognition ||
                (<any>window).msSpeechRecognition)();
    
            if (recognition) {
                recognition.lang = 'en-US';
                recognition.continuous = true;
                recognition.interimResults = false;
                recognition.maxAlternatives = 1;
    
                recognition.onstart = () => {
                    setIsRecordingSpeech(true);
                    setContent('...');
                };
    
                recognition.onnomatch = () => {
                    setIsRecordingSpeech(false);
                    setContent('');
                };
    
                recognition.onsoundend = () => {
                    setIsRecordingSpeech(false);
                };
    
                recognition.onerror = (_) => {
                    setIsRecordingSpeech(false);
                    setContent('');
                };
    
                recognition.onend = () => {
                    setIsRecordingSpeech(false);
                };
    
                recognition.onresult = (event) => {
                    setContent(event.results[0][0].transcript);
    
                    setIsRecordingSpeech(false);
                    recognition.stop();
                };
            }
        }
         

        return recognition;
    };
}
